// @ts-nocheck
import React from 'react';

export type ProgressItem = { url: string; status: string; message?: string };

export default function BulkProgressDrawer({ open, items, onClose }: { open: boolean; items: ProgressItem[]; onClose: ()=>void }) {
  if (!open) return null;
  const statusColor = (s: string) => {
    switch (s) {
      case 'Queued': return 'bg-gray-200 text-gray-700';
      case 'Extracting': return 'bg-purple-100 text-purple-800';
      case 'Enriched': return 'bg-emerald-100 text-emerald-800';
      case 'Saved': return 'bg-blue-100 text-blue-800';
      case 'Needs review': return 'bg-amber-100 text-amber-800';
      case 'Error': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-700';
    }
  };
  return (
    <div className="fixed inset-0 z-[95]">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="absolute bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 rounded-t-2xl p-4 max-h-[70vh] overflow-auto">
        <div className="flex items-center justify-between mb-2">
          <div className="font-semibold text-sm">Import progress</div>
          <button onClick={onClose} className="px-2 py-1 text-sm rounded hover:bg-gray-100 dark:hover:bg-gray-800">Close</button>
        </div>
        <div className="space-y-2">
          {items.map((it, i) => (
            <div key={i} className="rounded-lg border border-gray-200 dark:border-gray-800 p-2 text-sm">
              <div className="flex items-center justify-between">
                <div className="truncate max-w-[70%]" title={it.url}>{it.url}</div>
                <span className={`px-2 py-0.5 rounded text-xs ${statusColor(it.status)}`}>{it.status}</span>
              </div>
              {it.message && <div className="mt-1 text-xs text-gray-500">{it.message}</div>}
            </div>
          ))}
        </div>
        <div className="mt-2 text-xs text-gray-500">We accept most video links. Some may require manual review. <a className="text-blue-600 hover:underline" href="https://support.foodspotter.example/why-cant-we-parse" target="_blank" rel="noreferrer">Why can’t we parse this?</a></div>
      </div>
    </div>
  );
}
